export default __webpack_public_path__ + "static/media/culixinsheng.330a46eb.jpg";